import { createFileRoute } from "@tanstack/react-router";
import { validateChartsSearch } from "../services/charts-route";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/charts")({
  // The chart library session is browser-storage backed.
  ssr: ({ location }) =>
    /^\/charts\/[^/]+$/.test(location.pathname) &&
    !["/charts/saved", "/charts/shared"].includes(location.pathname),
  validateSearch: validateChartsSearch,
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ deps }) => ({ collection: "all" as const, search: deps.search }),
  head: () =>
    pageHead("Your Charts", {
      canonicalPath: "/charts",
      robots: "noindex, nofollow",
    }),
});
